import React from 'react';
import {string, node, number} from 'prop-types';
import Breadcrumbs from '../breadcrumbs/breadcrumbs';
import './title.css';

const Title = ({title, text, maxWidth}) => (
  <section className="title">
    <div className="container">
      <Breadcrumbs page={title} />
      <h1>{title}</h1>
      {text && (
        <div className="title__text" style={{maxWidth}}>
          {text}
        </div>
      )}
    </div>
  </section>
);

Title.propTypes = {
  title: string.isRequired,
  text: node,
  maxWidth: number
};

Title.defaultProps = {
  maxWidth: 502
};

export default Title;
